import { Box } from "@mui/material";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useMemo } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import TruncatedTextTooltip from "./TruncatedTextTooltip";
import MaintenanceBar from "./MaintenanceBar";
import "../assets/header.scss";
import { logo } from "./images";
import { Tag } from "./tag/Tag";
import { planTagsColor } from "./constants";
import { useSession } from "../hooks/useSession";

function CommonHeader({
  icon,
  textAfterIcon,
  rightSideComponent,
  navigation = null,
  showSpeedIcon = false,
  showMaintenanceBar = false,
  showPlan = false,
}) {
  const navigate = useNavigate();
  const { session } = useSession();

  const { isHideUnderMaintenanceBar } = useSelector((state) => state.common);
  const plan = session?.account?.account?.plan?.plan_name || "Base";

  const headerIcons = useMemo(
    () => ({
      wallet: (
        <AccountBalanceWalletIcon
          sx={{
            height: "18px",
            width: "18px",
            color: "#FFFFFF",
          }}
          className="wallet-icon"
        />
      ),
      backArrow: (
        <ArrowBackIcon
          onClick={() => {
            if (navigation) {
              navigate(navigation, { replace: true });
            } else {
              navigate(-1);
            }
          }}
          sx={{ cursor: "pointer" }}
        />
      ),
      speedIcon: <img src={logo} alt="speed-icon" />,
    }),
    [navigation]
  );

  return (
    <Box className="options-header">
      <Box className="options-header-container">
        <Box display="flex" alignItems="center" width="270px">
          {icon && (
            <Box mr="10px" display="flex">
              {headerIcons?.[icon]}
            </Box>
          )}
          {showSpeedIcon && (
            <Box mr="10px">
              <img src={logo} alt="speed-icon" style={{ marginTop: "3px" }} />
            </Box>
          )}
          <TruncatedTextTooltip
            textProps={{
              className: "default-text",
              font: "semibold",
              maxWidth: "350px",
              width: showPlan
                ? "fit-content"
                : {
                    xs: "180px",
                    sm: "350px",
                    md: "350px",
                  },
            }}
            textValue={textAfterIcon}
            fontSize={18}
            lineHeight={25}
          />
          {showPlan && (
            <Tag
              text={plan}
              style={{
                borderRadius: "30px",
                marginLeft: "8px",
                background: planTagsColor[plan],
              }}
            />
          )}
        </Box>
        <Box className="right-component">{rightSideComponent}</Box>
      </Box>
      {!isHideUnderMaintenanceBar && showMaintenanceBar && (
        <MaintenanceBar color="#F6D340" isFromBrowser={true} />
      )}
    </Box>
  );
}

export default CommonHeader;
